var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01850IconServiceArcSqlServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b1b473ab-063e-4611-aebb-1ce4d7f5f1ce",
    x1: 9,
    y1: 9.628,
    x2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbdffaf8-c9ae-4d97-81e3-4fd37bdb0695",
    x1: 9,
    y1: 13.343,
    x2: 9,
    y2: 9.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a6736b46-5abc-4b60-9819-eb5a3df3404e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.549,15.194c-.16.7-1.035,1.391-2.617,1.929a21.594,21.594,0,0,1-12.125.017C1.35,16.626.564,15.97.441,15.3c-.022-.118,0-1.966,0-1.966l17.136-.16S17.569,15.109,17.549,15.194Z",
    fill: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.001,
    cy: 13.294,
    rx: 8.576,
    ry: 2.965,
    transform: "translate(-0.133 0.091) rotate(-0.575)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.779,
    width: 14.442,
    height: 9.628,
    rx: 0.481,
    fill: "url(#b1b473ab-063e-4611-aebb-1ce4d7f5f1ce)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,12.54c-1.428-.224-1.484-1.251-1.484-2.912H7.58c0,1.661-.048,2.688-1.476,2.912a.8.8,0,0,0-.714.8h7.22A.8.8,0,0,0,11.9,12.54Z",
    fill: "url(#bbdffaf8-c9ae-4d97-81e3-4fd37bdb0695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,5.545V2.557H11.34V6.206h2.172V5.545ZM5.9,4.068A1.757,1.757,0,0,1,5.449,3.8a.389.389,0,0,1-.111-.292.312.312,0,0,1,.137-.267.593.593,0,0,1,.369-.094A1.426,1.426,0,0,1,6.7,3.4V2.642A2.4,2.4,0,0,0,5.844,2.5a1.492,1.492,0,0,0-.97.3.963.963,0,0,0-.361.79,1.187,1.187,0,0,0,.756,1.065,2.117,2.117,0,0,1,.541.317.351.351,0,0,1,.137.284.342.342,0,0,1-.137.275.662.662,0,0,1-.361.111,1.449,1.449,0,0,1-.961-.378V6.12a1.942,1.942,0,0,0,.944.206,1.715,1.715,0,0,0,1.039-.335.96.96,0,0,0,.378-.807.858.858,0,0,0-.223-.618A2.175,2.175,0,0,0,5.9,4.068Zm4.585,1.408a2.058,2.058,0,0,0,.292-1.116,2.1,2.1,0,0,0-.223-.971,1.6,1.6,0,0,0-.618-.661A1.775,1.775,0,0,0,9.073,2.5a1.913,1.913,0,0,0-.953.241,1.627,1.627,0,0,0-.653.687A2.124,2.124,0,0,0,7.2,4.437a2.092,2.092,0,0,0,.206.927,1.639,1.639,0,0,0,.61.653,1.773,1.773,0,0,0,.858.258l.756.858H10.7l-1.039-1A1.525,1.525,0,0,0,10.481,5.476Zm-.858-.223a.808.808,0,0,1-.67.309.79.79,0,0,1-.67-.318,1.328,1.328,0,0,1-.258-.858,1.353,1.353,0,0,1,.258-.859.857.857,0,0,1,.687-.318.771.771,0,0,1,.661.318,1.417,1.417,0,0,1,.241.859,1.288,1.288,0,0,1-.215.867Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01850IconServiceArcSqlServer);
export default __webpack_public_path__ + "static/media/01850-icon-service-Arc-SQL-Server.ede5445848d48a62cf770a5329de1fd6.svg";
export { ForwardRef as ReactComponent };